/* Installable Shopify theme asset; NOT installed by deploying Outback Ops.
 * Include with defer after Shopify's theme scripts. Requires both analytics and
 * marketing permission via https://shopify.dev/docs/api/customer-privacy.
 * Cart writes: https://shopify.dev/docs/api/ajax/reference/cart#update-cart-attributes
 * Custom lead forms can opt in with data-outback-attribution and call flush().
 * Normal same-origin checkout links/forms wait at most 2.2 seconds. Accelerated
 * checkout, third-party checkout scripts and other origins can bypass this hook;
 * their metadata propagation requires separate real-order verification.
 * No advertising events, customer details, cart items, or order mutations.
 */
(function (window, document) {
  'use strict';
  if (window.OutbackAttribution) return;
  var KEY = 'outback.attribution.v1';
  var SESSION = KEY + '.session';
  var TTL = 90 * 86400000;
  var SESSION_TTL = 30 * 60000;
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'campaign_id', 'campaign_name', 'adset_id', 'adset_name', 'adgroup_id', 'adgroup_name',
    'ad_id', 'ad_name', 'fbclid', 'gclid', 'gbraid', 'wbraid'];
  var state = null;
  var queue = Promise.resolve(true);
  var status = { state: 'initializing', error: null };
  var captured = false;
  var navigating = false;
  var resumedForms = new WeakSet();
  var pendingForms = new WeakSet();
  // A page restored from the back/forward cache keeps its JS state; without this reset a
  // customer who returns from checkout finds every checkout link/button dead.
  window.addEventListener('pageshow', function () { navigating = false; pendingForms = new WeakSet(); });

  function report(phase, error) {
    status = { state: phase, error: error || null };
    document.dispatchEvent(new CustomEvent('outback:attribution-status', { detail: status }));
  }
  function permitted() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch (_) { return false; }
  }
  function clean(value) {
    return typeof value === 'string' && value.trim() && !/[{}\u0000-\u001f]/.test(value)
      ? value.trim().slice(0, 500) : undefined;
  }
  function safeUrl(value) {
    try {
      var url = new URL(value, window.location.href);
      return /^https?:$/.test(url.protocol) ? (url.origin + url.pathname).slice(0, 2000) : undefined;
    } catch (_) { return undefined; }
  }
  function sanitizeTouch(value) {
    if (!value || typeof value !== 'object') return null;
    var touch = {};
    KEYS.forEach(function (key) { var v = clean(value[key]); if (v) touch[key] = v; });
    if (value.landing_page) touch.landing_page = safeUrl(value.landing_page);
    if (value.referrer) touch.referrer = safeUrl(value.referrer);
    if (clean(value.source)) touch.source = clean(value.source);
    if (Number.isFinite(Date.parse(value.occurred_at))) touch.occurred_at = new Date(value.occurred_at).toISOString();
    return touch.occurred_at && touch.landing_page ? touch : null;
  }
  function attributes() {
    var active = permitted() && state && state.expires_at > Date.now();
    return {
      outback_first_touch: active ? JSON.stringify(state.first_touch) : '',
      outback_last_touch: active ? JSON.stringify(state.last_touch) : '',
      outback_attribution_id: active ? state.attribution_id : ''
    };
  }
  function formKind(form) {
    try {
      var action = new URL(form.action || window.location.href, window.location.href);
      if (action.origin !== window.location.origin) return null;
      if (/\/(cart|checkout)\/?$/.test(action.pathname)) return 'cart';
      return form.hasAttribute('data-outback-attribution') ? 'lead' : null;
    } catch (_) { return null; }
  }
  function fillForms() {
    var values = attributes();
    document.querySelectorAll('form').forEach(function (form) {
      var kind = formKind(form);
      if (!kind) return;
      Object.keys(values).forEach(function (key) {
        var name = kind === 'cart' ? 'attributes[' + key + ']' : key;
        var field = form.querySelector('input[name="' + name + '"]');
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden'; field.name = name; form.appendChild(field);
        }
        field.value = values[key];
      });
    });
  }
  function clear() {
    state = null; captured = false;
    try { window.localStorage.removeItem(KEY); window.sessionStorage.removeItem(SESSION); }
    catch (_) { report('error', 'storage_unavailable'); }
    fillForms();
  }
  function capture() {
    if (!permitted()) return;
    if (captured && state && state.expires_at > Date.now()) return;
    var now = Date.now();
    try {
      var stored;
      try { stored = JSON.parse(window.localStorage.getItem(KEY) || 'null'); }
      catch (_) { stored = null; window.localStorage.removeItem(KEY); }
      if (stored && stored.version === 1 && stored.expires_at > now && stored.expires_at <= now + TTL &&
          /^[a-zA-Z0-9-]{16,64}$/.test(stored.attribution_id || '')) {
        var first = sanitizeTouch(stored.first_touch);
        var last = sanitizeTouch(stored.last_touch);
        if (first && last) state = { version: 1, attribution_id: stored.attribution_id,
          expires_at: stored.expires_at, first_touch: first, last_touch: last };
      }
      if (!state || state.expires_at <= now) { state = null; window.localStorage.removeItem(KEY); }
      var current = new URL(window.location.href);
      var referrer = document.referrer ? new URL(document.referrer) : null;
      var internal = referrer && referrer.origin === current.origin;
      var touch = { occurred_at: new Date(now).toISOString(), landing_page: safeUrl(current.href),
        source: referrer && !internal ? referrer.hostname : 'direct' };
      if (referrer && !internal) touch.referrer = safeUrl(referrer.href);
      KEYS.forEach(function (key) { var v = clean(current.searchParams.get(key)); if (v) touch[key] = v; });
      if (touch.utm_source) touch.source = touch.utm_source;
      var signature = JSON.stringify([touch.landing_page, touch.referrer || '',
        KEYS.map(function (key) { return touch[key] || ''; })]);
      var session;
      try { session = JSON.parse(window.sessionStorage.getItem(SESSION) || 'null'); } catch (_) { session = null; }
      var expiredSession = !session || !Number.isFinite(session.seen_at) || now - session.seen_at >= SESSION_TTL;
      var externalArrival = !internal && (!session || session.signature !== signature || expiredSession);
      if (!state) {
        if (!window.crypto || !window.crypto.randomUUID) { report('error', 'secure_id_unavailable'); return; }
        state = { version: 1, attribution_id: window.crypto.randomUUID(), expires_at: now + TTL,
          first_touch: touch, last_touch: touch };
      } else if (externalArrival) { state.last_touch = touch; }
      window.localStorage.setItem(KEY, JSON.stringify(state));
      window.sessionStorage.setItem(SESSION, JSON.stringify({
        seen_at: now, signature: internal && session ? session.signature : signature
      }));
      captured = true;
      report('captured');
      fillForms();
    } catch (_) { state = null; report('error', 'capture_storage_or_url_unavailable'); }
  }
  function writeCart() {
    // Resolve the payload when the serialized write starts, so revoked consent
    // cannot be reintroduced by a previously queued capture.
    if (!permitted()) clear();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url;
    try {
      url = new URL(root.replace(/\/?$/, '/') + 'cart/update.js', window.location.origin);
      if (url.origin !== window.location.origin) throw new Error();
    } catch (_) { report('error', 'invalid_cart_origin'); return Promise.resolve(false); }
    var controller = new AbortController();
    var timer;
    var timedOut = new Promise(function (resolve) {
      timer = window.setTimeout(function () {
        controller.abort(); report('error', 'cart_timeout'); resolve(false);
      }, 1800);
    });
    var request = Promise.resolve().then(function () {
      return window.fetch(url.href, { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attributes() }),
        signal: controller.signal });
    }).then(function (response) {
      if (!response.ok) { report('error', 'cart_http_' + response.status); return false; }
      if (permitted() && !state) { report('error', 'capture_unavailable'); return false; }
      report(permitted() ? 'synced' : 'consent_blocked'); return true;
    }).catch(function () { report('error', 'cart_unavailable'); return false; });
    return Promise.race([request, timedOut]).then(function (ok) { window.clearTimeout(timer); return ok; });
  }
  function flush() {
    if (permitted()) capture(); else clear();
    fillForms();
    queue = queue.then(writeCart, writeCart).catch(function () { report('error', 'cart_unavailable'); return false; });
    return queue;
  }
  function boundedFlush() {
    var timer;
    return Promise.race([flush(), new Promise(function (resolve) {
      timer = window.setTimeout(function () { report('error', 'checkout_flush_timeout'); resolve(false); }, 2200);
    })]).then(function (ok) { window.clearTimeout(timer); return ok; });
  }
  function onConsent() {
    if (permitted()) capture(); else { clear(); report('consent_blocked'); }
    void flush();
  }
  window.OutbackAttribution = {
    flush: flush,
    snapshot: function () { return permitted() && state && state.expires_at > Date.now() ? JSON.parse(JSON.stringify(state)) : null; },
    status: function () { return Object.assign({}, status); }
  };
  document.addEventListener('visitorConsentCollected', onConsent);
  document.addEventListener('DOMContentLoaded', fillForms);
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var anchor = event.target && event.target.closest && event.target.closest('a[href]');
    if (!anchor || (anchor.target && anchor.target !== '_self') || anchor.hasAttribute('download')) return;
    var url;
    try { url = new URL(anchor.href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    if (navigating) return;
    navigating = true;
    void boundedFlush().then(function () { window.location.assign(url.href); });
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !formKind(form)) return;
    fillForms();
    if (resumedForms.has(form)) { resumedForms.delete(form); return; }
    if (event.defaultPrevented) return;
    var action = new URL(form.action || window.location.href, window.location.href);
    var button = event.submitter;
    var checkout = /\/checkout\/?$/.test(action.pathname) || (button && button.name === 'checkout');
    if (!checkout) return;
    event.preventDefault();
    if (pendingForms.has(form)) return;
    pendingForms.add(form);
    void boundedFlush().then(function () {
      pendingForms.delete(form);
      fillForms();
      if (typeof form.requestSubmit !== 'function') {
        // Safari < 16 has event.submitter but no requestSubmit: submit natively (no submit event, so no re-entry).
        // Native submit() skips constraint validation and every submit listener (including the cart
        // guard in app.js), so re-run both now: the cart may have changed during the flush wait.
        resumedForms.add(form);
        var allowed = form.checkValidity() && form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        resumedForms.delete(form);
        if (!allowed) { if (typeof form.reportValidity === 'function') form.reportValidity(); return; }
        if (button && button.name) { var carry = document.createElement('input'); carry.type = 'hidden'; carry.name = button.name; carry.value = button.value || ''; form.appendChild(carry); }
        report('error', 'checkout_resubmit_fallback');
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
      resumedForms.add(form);
      try { form.requestSubmit(button || undefined); }
      catch (_) { resumedForms.delete(form); report('error', 'checkout_resubmit_failed'); }
    });
  }, true);
  if (window.Shopify && window.Shopify.customerPrivacy) onConsent();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) { clear(); report('error', 'consent_api_unavailable'); void flush(); }
        else onConsent();
      });
    } catch (_) { clear(); report('error', 'consent_api_unavailable'); void flush(); }
  } else { clear(); report('consent_api_unavailable'); void flush(); }
})(window, document);
